import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-medicina-nuclear',
  templateUrl: './medicina-nuclear.component.html',
  styleUrls: ['./medicina-nuclear.component.css']
})
export class MedicinaNuclearComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
